import { render, staticRenderFns } from "./project_detail.vue?vue&type=template&id=6c8ba5ae&scoped=true&"
import script from "./project_detail.vue?vue&type=script&lang=js&"
export * from "./project_detail.vue?vue&type=script&lang=js&"
import style0 from "./project_detail.vue?vue&type=style&index=0&id=6c8ba5ae&prod&lang=scss&scoped=true&"
import style1 from "./project_detail.vue?vue&type=style&index=1&id=6c8ba5ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ba5ae",
  null
  
)

export default component.exports